import React from "react";
import LegalLayout from "./LegalLayout";

// Privacy Policy — IT + EN. Drafted to be GDPR (Reg. UE 2016/679) +
// Italian Garante Privacy compliant. NOT legal advice — review with a
// lawyer before publishing to production.
export default function Privacy() {
  return (
    <LegalLayout
      title="Privacy Policy"
      sub="Informativa privacy"
      render={(lang) => (lang === "it" ? <ItContent /> : <EnContent />)}
    />
  );
}

const Titolare = () => (
  <p>
    <strong>Titolare del trattamento:</strong> Marco Marangoni — P.IVA 04018220964 — Piazza della Costituzione 12, 20068 Peschiera Borromeo (MI), Italia
    <br />
    <strong>Email di contatto privacy:</strong> <a href="mailto:info@homereel.it">info@homereel.it</a>
    <br />
    <strong>Responsabile della Protezione dei Dati (DPO):</strong> non designato (non obbligatorio ai sensi dell'art. 37 GDPR).
  </p>
);

function ItContent() {
  return (
    <>
      <p>
        La presente informativa descrive come Reelio (di seguito "Reelio" o "il Servizio"), accessibile su <strong>reelio.it</strong>, raccoglie e tratta i dati personali degli utenti ai sensi del Regolamento (UE) 2016/679 ("GDPR") e del D.Lgs. 196/2003 e ss.mm.ii.
      </p>

      <h2>1. Titolare del trattamento</h2>
      <Titolare />

      <h2>2. Tipologie di dati raccolti</h2>
      <h3>2.1 Dati forniti dall'utente</h3>
      <ul>
        <li><strong>Dati di registrazione:</strong> nome, indirizzo email, password (memorizzata solo in forma cifrata bcrypt — non è leggibile neanche da noi).</li>
        <li><strong>Dati del brand:</strong> nome dell'attività, logo, colori, settore, descrizione, eventuali immagini caricate dall'utente.</li>
        <li><strong>Contenuti generati:</strong> testi (titoli, hook, caption), immagini AI, audio TTS, reel video, caroselli — creati su input dell'utente.</li>
        <li><strong>Dati di fatturazione:</strong> intestazione e indirizzo (gestiti direttamente da Stripe; Reelio conserva solo l'identificativo cliente Stripe e l'email).</li>
      </ul>
      <h3>2.2 Dati raccolti automaticamente</h3>
      <ul>
        <li>Indirizzo IP, user-agent del browser, timestamp delle richieste (log tecnici del server).</li>
        <li>Token di sessione JWT memorizzato nel <code>localStorage</code> del browser.</li>
        <li>Dati di utilizzo aggregati (numero reel/immagini generati, errori applicativi).</li>
        <li>Cookie analitici (solo se l'utente acconsente — vedi <a href="/cookie-policy">Cookie Policy</a>).</li>
      </ul>
      <h3>2.3 Dati NON raccolti</h3>
      <p>
        Reelio <strong>non raccoglie</strong> dati di carte di credito o bancari (sono gestiti direttamente da Stripe), né categorie particolari di dati ai sensi dell'art. 9 GDPR (salute, religione, orientamento politico, dati biometrici per identificazione).
      </p>

      <h2>3. Finalità e basi giuridiche</h2>
      <table>
        <thead>
          <tr>
            <th>Finalità</th>
            <th>Base giuridica</th>
            <th>Conservazione</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Erogazione del Servizio (registrazione, generazione contenuti, gestione account)</td>
            <td>Esecuzione contratto (art. 6.1.b GDPR)</td>
            <td>Per tutta la durata dell'account + 30 giorni dopo la cancellazione</td>
          </tr>
          <tr>
            <td>Fatturazione e adempimenti fiscali</td>
            <td>Obbligo di legge (art. 6.1.c GDPR)</td>
            <td>10 anni (art. 2220 c.c.)</td>
          </tr>
          <tr>
            <td>Sicurezza, prevenzione frodi, log tecnici</td>
            <td>Legittimo interesse (art. 6.1.f GDPR)</td>
            <td>12 mesi</td>
          </tr>
          <tr>
            <td>Comunicazioni di servizio (es. modifiche, scadenze)</td>
            <td>Esecuzione contratto</td>
            <td>Durata account</td>
          </tr>
          <tr>
            <td>Analisi statistica aggregata (PostHog)</td>
            <td>Consenso (art. 6.1.a GDPR)</td>
            <td>Fino a revoca del consenso</td>
          </tr>
          <tr>
            <td>Programma referral (codici invito + cashback)</td>
            <td>Esecuzione contratto + Consenso</td>
            <td>Durata account</td>
          </tr>
        </tbody>
      </table>

      <h2>4. Destinatari dei dati (fornitori e trasferimenti extra-UE)</h2>
      <p>
        Per erogare il Servizio condividiamo dati con i seguenti fornitori, tutti vincolati da accordi di trattamento (DPA) e clausole contrattuali standard (SCC) ove applicabili.
      </p>
      <table>
        <thead>
          <tr>
            <th>Fornitore</th>
            <th>Servizio</th>
            <th>Paese</th>
            <th>Garanzia trasferimento</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>Stripe Payments Europe Ltd.</td><td>Pagamenti, sub abbonamenti</td><td>Irlanda + USA</td><td>EU-US Data Privacy Framework</td></tr>
          <tr><td>OpenAI, L.L.C.</td><td>Generazione testo (Whisper, GPT) e audio (TTS)</td><td>USA</td><td>EU-US DPF + SCC</td></tr>
          <tr><td>Anthropic, PBC</td><td>Generazione testo (Claude)</td><td>USA</td><td>Standard Contractual Clauses</td></tr>
          <tr><td>Google LLC</td><td>Generazione immagini (Gemini Nano Banana)</td><td>USA / Europa</td><td>EU-US DPF + SCC</td></tr>
          <tr><td>MongoDB Atlas</td><td>Storage database</td><td>Francoforte (UE)</td><td>Nessun trasferimento extra-UE</td></tr>
          <tr><td>Cloudflare, Inc.</td><td>CDN, sicurezza, DDoS</td><td>Globale</td><td>EU-US DPF + SCC</td></tr>
          <tr><td>PostHog Inc.</td><td>Analytics (solo con consenso)</td><td>USA / UE</td><td>SCC</td></tr>
        </tbody>
      </table>

      <h2>5. Conservazione dei dati</h2>
      <p>
        I dati personali sono conservati per il tempo strettamente necessario al perseguimento delle finalità per cui sono raccolti. Alla cancellazione dell'account, i dati sono eliminati entro 30 giorni, fatti salvi gli obblighi di legge (fatturazione: 10 anni; log di sicurezza: 12 mesi).
      </p>

      <h2>6. Diritti dell'interessato</h2>
      <p>Hai il diritto di:</p>
      <ul>
        <li><strong>Accesso</strong> (art. 15) — ricevere copia dei tuoi dati</li>
        <li><strong>Rettifica</strong> (art. 16) — correggere dati inesatti</li>
        <li><strong>Cancellazione</strong> (art. 17) — "diritto all'oblio"</li>
        <li><strong>Limitazione</strong> (art. 18) — sospendere il trattamento</li>
        <li><strong>Portabilità</strong> (art. 20) — ottenere i dati in formato strutturato</li>
        <li><strong>Opposizione</strong> (art. 21) — opporsi al trattamento</li>
        <li><strong>Revoca del consenso</strong> in qualsiasi momento (per i trattamenti basati sul consenso)</li>
        <li><strong>Reclamo al Garante Privacy</strong> (<a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer">garanteprivacy.it</a>) se ritieni che il trattamento violi il GDPR</li>
      </ul>
      <p>
        Per esercitare i tuoi diritti scrivi a <a href="mailto:info@homereel.it">info@homereel.it</a>. Risponderemo entro 30 giorni.
      </p>

      <h2>7. Sicurezza dei dati</h2>
      <p>
        Adottiamo misure tecniche e organizzative adeguate per proteggere i tuoi dati: cifratura HTTPS, password hashate con bcrypt, tokenizzazione delle sessioni (JWT), accessi limitati al personale autorizzato, backup giornalieri, monitoraggio degli accessi anomali.
      </p>

      <h2>8. Trattamento di immagini caricate dall'utente</h2>
      <p>
        L'utente può caricare immagini per generare reel o caroselli. Tali immagini possono contenere volti di terze persone. <strong>È responsabilità dell'utente</strong> aver ottenuto il consenso o disporre della base giuridica adeguata per il trattamento delle immagini di terzi. Reelio agisce in qualità di responsabile del trattamento (art. 28 GDPR) per conto dell'utente.
      </p>

      <h2>9. Programma referral</h2>
      <p>
        Quando un utente invita un terzo tramite codice di referral, l'invitato fornisce volontariamente i propri dati registrandosi al Servizio. Al referente verrà mostrata solo una versione mascherata dell'email dell'invitato (es. <code>m***@example.com</code>) come misura di tutela della privacy.
      </p>

      <h2>10. Modifiche all'informativa</h2>
      <p>
        Eventuali modifiche saranno pubblicate su questa pagina. In caso di modifiche sostanziali invieremo notifica via email agli utenti registrati.
      </p>
    </>
  );
}

function EnContent() {
  return (
    <>
      <p>
        This privacy policy describes how Reelio (the "Service"), available at <strong>reelio.it</strong>, collects and processes users' personal data in accordance with Regulation (EU) 2016/679 ("GDPR") and Italian Legislative Decree 196/2003 as amended.
      </p>

      <h2>1. Data Controller</h2>
      <p>
        <strong>Controller:</strong> Marco Marangoni — VAT 04018220964 — Piazza della Costituzione 12, 20068 Peschiera Borromeo (MI), Italy
        <br />
        <strong>Privacy contact email:</strong> <a href="mailto:info@homereel.it">info@homereel.it</a>
        <br />
        <strong>Data Protection Officer (DPO):</strong> not appointed (not mandatory under Article 37 GDPR).
      </p>

      <h2>2. Categories of data collected</h2>
      <h3>2.1 Data provided by the user</h3>
      <ul>
        <li><strong>Registration:</strong> name, email, password (stored only in bcrypt-hashed form — unreadable even to us).</li>
        <li><strong>Brand profile:</strong> business name, logo, colors, industry, description, uploaded images.</li>
        <li><strong>Generated content:</strong> texts, AI images, TTS audio, video reels, carousels — created from user input.</li>
        <li><strong>Billing:</strong> handled directly by Stripe; we retain only the Stripe customer ID and email.</li>
      </ul>
      <h3>2.2 Data collected automatically</h3>
      <ul>
        <li>IP address, browser user-agent, request timestamps (server logs).</li>
        <li>JWT session token stored in browser <code>localStorage</code>.</li>
        <li>Aggregated usage data.</li>
        <li>Analytics cookies (only with consent — see <a href="/cookie-policy">Cookie Policy</a>).</li>
      </ul>
      <h3>2.3 Data NOT collected</h3>
      <p>
        Reelio does <strong>not</strong> collect credit-card or banking data (handled by Stripe), nor special category data under Article 9 GDPR.
      </p>

      <h2>3. Purposes and legal bases</h2>
      <table>
        <thead>
          <tr><th>Purpose</th><th>Legal basis</th><th>Retention</th></tr>
        </thead>
        <tbody>
          <tr><td>Service delivery</td><td>Contract performance (Art. 6.1.b)</td><td>Account lifetime + 30 days</td></tr>
          <tr><td>Invoicing &amp; tax</td><td>Legal obligation (Art. 6.1.c)</td><td>10 years</td></tr>
          <tr><td>Security, fraud prevention</td><td>Legitimate interest (Art. 6.1.f)</td><td>12 months</td></tr>
          <tr><td>Analytics (PostHog)</td><td>Consent (Art. 6.1.a)</td><td>Until consent withdrawn</td></tr>
          <tr><td>Referral program</td><td>Contract + Consent</td><td>Account lifetime</td></tr>
        </tbody>
      </table>

      <h2>4. Recipients (sub-processors and international transfers)</h2>
      <p>To deliver the Service we share data with the following providers, bound by DPAs and SCCs where applicable.</p>
      <table>
        <thead><tr><th>Provider</th><th>Service</th><th>Country</th><th>Transfer safeguard</th></tr></thead>
        <tbody>
          <tr><td>Stripe Payments Europe</td><td>Payments</td><td>Ireland + USA</td><td>EU-US DPF</td></tr>
          <tr><td>OpenAI</td><td>Text/audio generation</td><td>USA</td><td>EU-US DPF + SCC</td></tr>
          <tr><td>Anthropic</td><td>Text (Claude)</td><td>USA</td><td>SCC</td></tr>
          <tr><td>Google LLC</td><td>Image generation (Gemini)</td><td>USA / EU</td><td>EU-US DPF + SCC</td></tr>
          <tr><td>MongoDB Atlas</td><td>Database</td><td>Frankfurt (EU)</td><td>No transfer</td></tr>
          <tr><td>Cloudflare</td><td>CDN, security</td><td>Global</td><td>EU-US DPF + SCC</td></tr>
          <tr><td>PostHog</td><td>Analytics (consent-based)</td><td>USA / EU</td><td>SCC</td></tr>
        </tbody>
      </table>

      <h2>5. Data retention</h2>
      <p>Personal data is retained only as long as necessary for the purposes for which it was collected. Upon account deletion, data is removed within 30 days, subject to legal retention obligations.</p>

      <h2>6. Your rights</h2>
      <ul>
        <li><strong>Access</strong> (Art. 15)</li>
        <li><strong>Rectification</strong> (Art. 16)</li>
        <li><strong>Erasure</strong> (Art. 17)</li>
        <li><strong>Restriction</strong> (Art. 18)</li>
        <li><strong>Portability</strong> (Art. 20)</li>
        <li><strong>Objection</strong> (Art. 21)</li>
        <li><strong>Withdraw consent</strong> at any time</li>
        <li><strong>Lodge a complaint</strong> with the Italian Garante Privacy (<a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer">garanteprivacy.it</a>)</li>
      </ul>
      <p>To exercise your rights write to <a href="mailto:info@homereel.it">info@homereel.it</a>. We will respond within 30 days.</p>

      <h2>7. Security</h2>
      <p>We use HTTPS encryption, bcrypt password hashing, JWT session tokens, restricted access, daily backups, and intrusion monitoring.</p>

      <h2>8. User-uploaded images</h2>
      <p>Users may upload images that contain third-party faces. It is the user's responsibility to have obtained consent for such processing. Reelio acts as a processor (Art. 28 GDPR) on the user's behalf.</p>

      <h2>9. Referral program</h2>
      <p>When a user invites someone via referral code, the invitee voluntarily provides their data upon registration. The referrer only sees a masked version of the invitee's email (e.g. <code>m***@example.com</code>) as a privacy-by-design measure.</p>

      <h2>10. Changes to this policy</h2>
      <p>Updates will be published on this page. Substantial changes will be notified via email to registered users.</p>
    </>
  );
}
